import { Colors } from "src/styles/DesignSystem";
import styled from "styled-components";

export const MarcasContainer = styled.section`
    width: 100%;
    background-color: ${Colors.lighBrown};
    border-radius: 60px 60px 0 0;

    margin-top: 5%;
    padding: 2.5%;
    padding-bottom: 15%;

    .swiper{
        width: 65%;
        margin: 0 auto;
        padding: 2% 0;

        .swiper-pagination{
            bottom: 0;

            &-bullet-active{
                border: 1px solid ${Colors.brown};
                background: ${Colors.orange};
            }
        }

        .swiper-wrapper, .swiper-slide{
            display: flex;
            align-items: center;
        }
    }

    @media screen and (min-width: 320px) and (max-width: 480px){
        border-radius: 20px 20px 0 0;
        padding: 2.5% 2.5% 25% 2.5%;

        .swiper{
            padding: 7.5% 0;
        }
    }
`;

export const MarcaImage = styled.img`
    width: 65%;
    filter: grayscale(90%);
    transition: all ease .25s;

    &:hover{
        filter: grayscale(0%);
    }

    @media screen and (min-width: 320px) and (max-width: 480px){
        width: 75%;
    }
`;